<template>
  <div class="TournamentPage content inner-grid-container" v-on:dragend="endDrag">
    <div class="banner">
      <Banner v-bind:text="tournament.name"></Banner>
    </div>
    <div class="existingTeams left">
      <div class="infoCard shadow">
        <div class="tex">NUMBER OF TEAMS: {{tournament.teams.length}}</div>
        <div style="color: red;" v-if="tournament.teams.length >= 9">Brackets for more than 8 teams are currently not supported.</div>
        <button class="buttonBigStyle" v-on:click="openBracket">VIEW BRACKET</button>
      </div>
      <button v-on:click="openExistingTeams" class="collapsible shadow" v-bind:class="collapsibleClass">ADD EXISTING TEAMS TO THIS TOURNAMENT</button>
        <div class="collapsible-content" v-bind:class="collapsibleContentClass">
          <div class="addText tex"> DRAG & DROP TO ADD EXISTING TEAMS</div>
          <div v-bind:draggable="true" v-on:dragstart="drag">
        <TeamCard class="dragging" v-bind:edit="false" v-bind:draggable="true" v-on:dragstart="drag" v-bind:id="team.id" v-for="team in availableTeams" :key="team.id" v-bind:teamId="team.id" v-bind:tournamentId="tournament.id"></TeamCard>
      </div>
        </div>
    </div>
    <div class="right">
      <div class="addText">TEAMS</div>
      <AddBox v-model="teamName" v-bind:placeholderText="placeholderText" v-on:add="addNewTeam"></AddBox>
      <div class="teamcard-holder" v-bind:class="teamHolderClass" v-on:dragover="allowDrop" v-on:drop="drop">
        <TeamCard v-for="teamId in reversedTeamList" :key="teamId" v-bind:teamId="teamId" v-bind:edit="true" v-bind:tournamentId="tournament.id"></TeamCard>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import TeamCard from "@/components/TeamCard.vue";
import AddBox from "@/components/AddBox.vue";
export default {
  name: "TournamentPage",
  components: {
    Banner,
    TeamCard,
    AddBox
  },
  data: function() {
    return {
      teamName: "",
      placeholderText: "ENTER TEAM NAME",
      dragging: false,
      collapsibleClass: "",
      collapsibleContentClass: "hide"
    };
  },

  computed: {
    tournament() {
      return this.$store.getters.tournament(this.$route.params.tournamentId);
    },
    reversedTeamList() {
      return this.tournament.teams.slice().reverse();
    },
    availableTeams() {
      return this.allTeams.filter(
        team => !this.tournamentTeams.includes(team.id)
      );
    },
    allTeams() {
      return this.$store.state.teams;
    },
    tournamentIndex() {
      return this.$store.getters.tournamentIndex(
        this.$route.params.tournamentId
      );
    },
    tournamentTeams() {
      return this.$store.state.tournaments[this.tournamentIndex].teams;
    },
    teamHolderClass() {
      if (this.dragging) {
        return "light-glow";
      } else {
        return "test";
      }
    }
  },
  methods: {
    addNewTeam() {
      this.$store.dispatch("addNewTeam", {
        teamName: this.teamName,
        tournamentId: this.tournament.id
      });
      this.teamName = "";
    },
    allowDrop(evt) {
      evt.preventDefault();
    },
    drop(evt) {
      evt.preventDefault();
      this.dragging = false;
      this.$store.dispatch("addExistingTeam", {
        tournamentId: this.tournament.id,
        teamId: evt.dataTransfer.getData("text")
      });
    },
    drag(evt) {
      this.dragging = true;
      evt.dataTransfer.setData("text", evt.target.id);
    },
    endDrag() {
      this.dragging = false;
    },
    openExistingTeams() {
      if (this.collapsibleClass == "active") {
        this.collapsibleClass = "";
      } else {
        this.collapsibleClass = "active";
      }

      if (this.collapsibleContentClass == "show") {
        this.collapsibleContentClass = "hide";
      } else {
        this.collapsibleContentClass = "show";
      }
    },
    openBracket() {
      this.$router.push("/tournament/" + this.tournament.id + "/bracket");
    }
  }
};
</script>


<style scoped>
.inner-grid-container {
  display: grid;
  grid-column-gap: 30px;
  grid-template-columns: auto 500px 500px auto;
  grid-template-areas:
    "banner banner banner banner"
    "leftleft left right rightright";
  grid-row-gap: 25px;
}

.existingTeams {
  grid-area: left;
  justify-self: stretch;
}
.right {
  grid-area: right;
  justify-self: center;
}
.teamcard-holder {
  /*background-color: white;*/
  min-height: 100px;
}
.tex {
  font-size: 16px;
  margin-bottom: 10px;
}

.infoCard {
  background-color: #33333333;
  text-align: center;
  width: -webkit-fill-available;
  padding: 10px;
  margin-bottom: 15px;
  color: orange;
}

/*COLLAPSIBLE source: https://www.w3schools.com/howto/howto_js_collapsible.asp*/
.collapsible {
  background-color: #33333333;
  color: orange;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
}

.active,
.collapsible:hover {
  background-color: #44444444;
}

.collapsible-content {
  padding: 0 18px;
  background-color: #44444444;
  max-height: 410px;
  overflow: auto;
}

.hide {
  display: none;
}

.show {
  display: block;
}

.collapsible:after {
  content: "\02795"; /* Unicode character for "plus" sign (+) */
  font-size: 13px;
  color: orange;
  float: right;
  margin-left: 5px;
}

.active:after {
  content: "\2796"; /* Unicode character for "minus" sign (-) */
}

@media (max-width: 600px) {
  .inner-grid-container {
    grid-template-columns: auto auto auto auto;
    grid-column-gap: 0;
    grid-template-areas:
      "banner"
      "left"
      "right"
      "leftleft"
      "rightright";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TournamentPage.vue